import React from 'react';
import * as styles from '../css/impulse-button-section.css';
import SectionDetailsLink from '../components/SectionDetailsLink';
import { sectionIds } from './utils';
import SectionDetailsLinkGeneric from '../components/SectionDetailsLinkGeneric';


const ImpulseDetailsLinkSection = () => (
    <div className={styles.root}>
        <SectionDetailsLink navigateTo={`/#${sectionIds.contactId}`}>
            Contact us
        </SectionDetailsLink>
        <SectionDetailsLinkGeneric component="a" href="/impulse_efficiency.pdf">
            Explore the full story
        </SectionDetailsLinkGeneric>
    </div>
)

export default ImpulseDetailsLinkSection;
